import TabsContainer from '@nile/mangifera/src/Containers/TableContainers/TabsContainer';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

function TaskViewPage({ match }) {
  const [activeView, setActiveView] = useState(null);
  const [records, setRecords] = useState([]);
  const [personalization, setPersonalization] = useState('');

  const actions = {
    setActiveView: setActiveView,
    setPersonalization: setPersonalization,
    personalization: personalization,
    activeView: activeView,
    records: records,
    setRecords: setRecords
  };

  return (
    <div>
      <TabsContainer actions={actions} />
    </div>
  );
}

export default withRouter(TaskViewPage);
